import { useState, useEffect, useCallback } from 'react';
import { buildEdgeAuthStartUrl } from '@cortex/core-types';
import { authApi } from '../lib/api.js';

interface User {
  email: string;
  name: string;
  picture: string;
}

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

/**
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business Google OAuth認証フック。ログイン/ログアウト・ユーザー情報取得・認証状態管理を提供
 * @graph-connects authApi [calls] 認証APIクライアント呼び出し
 */
export function useAuth() {
  const [state, setState] = useState<AuthState>({
    user: null,
    isAuthenticated: false,
    isLoading: true,
  });

  useEffect(() => {
    let cancelled = false;
    authApi
      .getCurrentUser()
      .then((res) => {
        if (!cancelled) {
          setState({
            user: res.user,
            isAuthenticated: res.user !== null,
            isLoading: false,
          });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setState({ user: null, isAuthenticated: false, isLoading: false });
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const login = useCallback(() => {
    window.location.href = buildEdgeAuthStartUrl(window.location.href);
  }, []);

  const logout = useCallback(async () => {
    await authApi.logout();
    setState({ user: null, isAuthenticated: false, isLoading: false });
    window.location.href = '/login';
  }, []);

  return { ...state, login, logout };
}
